import { IonSpinner, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { boat } from 'ionicons/icons';
import React, { Component }  from 'react';
import { RouteComponentProps } from "react-router-dom";
import '../pages/Main.css'; 

import { LANGUAGE, GetStr } from "../language/Language";

interface NoMoreProp {
    nomore : boolean;
};

const NoMoreContent : React.FC<NoMoreProp> = ({ nomore }) => {
    
    return (
        <div className="nomore-content">
            {
                nomore ?
            <div>
                <IonIcon icon={boat} />&nbsp;&nbsp; { GetStr(LANGUAGE.TXT_NO_MORE_CONTENT) }
            </div>
                :
            <IonSpinner name="dots"></IonSpinner>
            }
        </div>
    );
};
  
export default NoMoreContent;